import { ChargedBomb } from 'game/extended/creatures/goblins/abilities/charge_bomb/charged_bomb'

export default {
    events: {},
    effects: {
        ChargedBomb
    },
}